import { useState } from "react"
import { PlusCircle } from "lucide-react"
import { AssessmentFilters } from "../components/ui/school/assessment-management/school-assessment-filters"
import { AssessmentStats } from "../components/ui/school/assessment-management/school-assessment-stats"
import { AssessmentTabs } from "../components/ui/school/assessment-management/school-assessment-tabs"
import { AssessmentCard } from "../components/ui/school/assessment-management/school-assessment-card"
import { SchoolSidebar } from "../components/ui/school/school-dashboard/school-sidebar"
import { assessmentsData } from "../lib/school-assessments-data"

const AssessmentManagementPage = () => {
  const [filters, setFilters] = useState({
    searchQuery: "",
    classFilter: "",
    studentFilter: "",
    courseFilter: "",
    careerPathFilter: "",
  })

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters)
    console.log("Filters changed:", newFilters)
  }

  const handleTabChange = (tab) => {
    console.log("Tab changed:", tab)
  }

  const handleAssign = (id) => {
    console.log("Assign assessment:", id)
  }

  const handleEdit = (id) => {
    console.log("Edit assessment:", id)
  }

  const handleDelete = (id) => {
    console.log("Delete assessment:", id)
  }

  return (
    <div className="flex min-h-screen bg-gray-100">
      {/* School Sidebar */}
      <SchoolSidebar />

      {/* Main Content - Using same pattern as SchoolDashboardPage */}
      <main className="flex-1 lg:ml-64 p-4 md:p-8 overflow-y-auto">
        {/* Page Heading */}
        <div className="flex flex-wrap justify-between items-center gap-4 mb-8">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">
              Assessment Management
            </h1>
            <p className="text-gray-500 mt-2 text-sm font-medium">
              Manage, track, and analyze student assessments effectively.
            </p>
          </div>
          <button className="flex min-w-[160px] cursor-pointer items-center justify-center gap-2 overflow-hidden rounded-lg h-12 px-6 bg-teal-600 hover:bg-teal-700 transition-colors text-white text-sm font-bold leading-normal tracking-wide shadow-sm">
            <PlusCircle className="h-5 w-5" />
            <span className="truncate">Create Assessment</span>
          </button>
        </div>

        {/* Filters */}
        <AssessmentFilters onFilterChange={handleFilterChange} />

        {/* Stats */}
        <AssessmentStats />

        {/* Tabs */}
        <AssessmentTabs onTabChange={handleTabChange} />

        {/* Assessment Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 py-8">
          {assessmentsData.map((assessment) => (
            <AssessmentCard
              key={assessment.id}
              assessment={assessment}
              onAssign={handleAssign}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          ))}
        </div>
      </main>
    </div>
  )
}

export default AssessmentManagementPage